/* eslint no-param-reassign: "off" */

export default {
  install: (Vue, currencyList = []) => {
    Vue.prototype.$currencyList = currencyList;
  },
};



// WEBPACK FOOTER //
// ./src/plugin/currency.js